import React from "react";
const ConvertersContext = React.createContext(void 0);
const useConverters = () => {
  const ctx = React.useContext(ConvertersContext);
  if (!ctx) {
    throw new Error("ConvertersContext not provided.");
  }
  return ctx;
};
export {
  ConvertersContext,
  useConverters
};
//# sourceMappingURL=context.js.map
